import { db } from "../../../service/API";

export class ProfileViewerConnector {
  constructor(userData) {
    this.userId = userData.userId;
    this.socId = userData.socId;
  }

  getViewersMail(listPlayerSelected, sid = this.socId) {
    return new Promise((resolve, reject) => {
      db.get("/ProfileViewerConnector/ViewersMail/" + sid + "/" + listPlayerSelected)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get viewers mail failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get viewers mail " + err.message);
        });
    });
  }

  getViewersData(sid = this.socId) {
    return new Promise((resolve, reject) => {
      db.get("/ProfileViewerConnector/ViewersData/" + sid)
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("get all viewers failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on get all viewers " + err.message);
        });
    });
  }

  insertViewerData(viewerObject, sid = this.socId, uid = this.userId) {
    return new Promise((resolve, reject) => {
      db.post("/ProfileViewerConnector/insertViewerData/", {
        sid: sid,
        uid: uid,
        viewer: viewerObject,
      })
        .then((response) => {
          if (response.status == 201) {
            return resolve(response.data);
          } else {
            return reject("insert viewers failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on insert viewers " + err.message);
        });
    });
  }

  updateViewerData(viewerObject, vid = this.viewerId) {
    return new Promise((resolve, reject) => {
      db.put("/ProfileViewerConnector/updateViewerData/", {
        vid: vid,
        viewer: viewerObject,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("update viewers failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error on update viewers " + err.message);
        });
    });
  }

  disableViewerData(vid, sid = this.socId) {
    return new Promise((resolve, reject) => {
      db.put("/ProfileViewerConnector/disableViewerData/", {
        vid: vid,
        sid: sid,
      })
        .then((response) => {
          if (response.status == 200) {
            return resolve(response.data);
          } else {
            return reject("disable viewers failed with status " + response.status);
          }
        })
        .catch((err) => {
          return reject("Error disable viewers " + err.message);
        });
    });
  }
}
